<template>
  <div class="products-index-base" :style="styles">
    <h1><img src="/static/img/recommend/lp/touwa/products/newcorner_lp_head_touwa.png" alt=""></h1>
    <p class="page-lead">斗弥先生の「属性開抛」ほか、<br>代表的な占いをご紹介します。</p>
    <div
      class="link-block-wrap"
      v-for="(item, lidx) in counselorInfos.information.products.productsIndexLinkList"
      :key="`linkitem-${lidx}`"
    >
      <link-block
        :color-scheme="linkBlockColorScheme"
        :link-item-list="item"
      />
    </div>
    <!--
    <banner-block
      :banner-list="counselorInfos.information.products.footBannerList"
    />
    -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />

    <lp-footer
      :color-scheme="footerColorScheme"
      :menu-list="footerMenuList"
      :scroll-pos="scrollPos"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import * as type from '@/utvStore/store/mutation-types'
import moment from "moment";

import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'
import BannerBlock from '../partials/BannerBlock'
import LinkBlock from '../partials/LinkBlock'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

export default {
  name: 'ProductsTouwaIndex',
  components: {
    BannerBlock,
    LinkBlock,
    LpFooter,
    RecommendBlockPlus,
  },
  props: {
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      scrollPos: -1,
    }
  },
  computed: {
    counselorInfos(){
      return BASIC_DATA.touwa
    },
    linkBlockColorScheme() {
      const sch = this.counselorInfos.colorScheme
      return {
        keyColor: sch.baseBg,
        fontColor: '#32373f',
        borderColor: sch.baseBg,
      }
    },
    footerColorScheme() {
      const sch = this.counselorInfos.colorScheme
      return {
        keyColor: sch.baseBg,
        fontColor: 'white',
        second: sch.second,
      }
    },
    footerMenuList() {
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('斗弥さんカウンセラーデータ%O', this.counselorInfos)
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
  }
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";

.products-index-base {
  width: 100%;
  background: url(/static/img/recommend/lp/touwa/products/bg_patterns_1.png) repeat-y center top;
  background-size: 100% auto;
}
h1 {
  margin: 0 0 20px;
}
.page-lead {
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  margin: 0;
}
/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/touwa/ProductsTouwaIndex.vue